import { render, staticRenderFns } from "./CompanyDocumentArchivedPage.vue?vue&type=template&id=64812b62&scoped=true&"
import script from "./CompanyDocumentArchivedPage.vue?vue&type=script&lang=js&"
export * from "./CompanyDocumentArchivedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64812b62",
  null
  
)

export default component.exports